import { getDefaultQueryStringProvider } from './getDefaultQueryStringProvider';
import QueryStringProvider from './interfaces/QueryStringProvider';

export function getRedirectUrl(queryStringProvider?: QueryStringProvider): string {
  const provider = queryStringProvider || getDefaultQueryStringProvider();
  const queryString = provider.GetQueryString();
  const urlParams = new URLSearchParams(queryString);
  const result = urlParams.get('fromURI') ?? sessionStorage.getItem('fromURI') ?? '/';
  if (result === '') {
    return '/';
  }
  return result;
}
